import { temAcesso } from '@/shared/auth/temAcesso'

const Jobs = () => import('./Jobs.vue')
const JobDetalhar = () => import('./JobDetalhar.vue')

export default {
    path: 'jobs',
    name: 'Jobs',
    component: Jobs,
    beforeEnter: (to, from, next) => {
        if (temAcesso('ADMIN-JOBS-00')) {
            next()
        }
    },
    children: [
        {
            path: ':jobId',
            name: 'Jobs_Detalhar',
            component: JobDetalhar,
            beforeEnter: (to, from, next) => {
                if (temAcesso('ADMIN-JOBS-00')) {
                    next()
                }
            }
        }
    ]
}
